const tutorialRefs = new Map<string, HTMLElement | null>()

export const registerTutorialRef = (id: string, element: HTMLElement | null) => {
  if (element) {
    tutorialRefs.set(id, element)
  } else {
    tutorialRefs.delete(id)
  }
}

export const getTutorialRef = (id: string): HTMLElement | null => {
  return tutorialRefs.get(id) || null
}
